import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { breakpoints } from '@avangard/ui/utils';
import { Button, ListToolbar } from '@avangard/ui/core';

type ListFiltersProps = {
    children: React.ReactNode;
    className?: string;
    issetFilters?: boolean;
    hideClearButton?: boolean;
    onResetFilters?: () => void;
};

const List = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    > * {
        min-width: 250px;
        margin-bottom: 10px;

        &:not(:last-child) {
            margin-inline-end: 8px;

            ${breakpoints.down('xs')} {
                margin-inline-end: 0;
                margin-bottom: 10px;
            }
        }

        ${breakpoints.down('md')} {
            min-width: auto;
            width: calc(33.3333% - 8px);
        }

        ${breakpoints.down('sm')} {
            width: calc(50% - 8px);
        }

        ${breakpoints.down('xs')} {
            min-width: 100%;
        }
    }

    ${breakpoints.down('md')} {
        width: 100%;
    }
`;

const ResetFilters = styled.div`
    display: block;
`;

const ListFilters = (props: ListFiltersProps): React.ReactElement => {
    const { hideClearButton = true, issetFilters, onResetFilters, children } = props;

    const { t } = useTranslation(['common']);

    return (
        <ListToolbar>
            <List>{children}</List>

            {!hideClearButton && issetFilters ? (
                <ResetFilters>
                    <Button onClick={onResetFilters}>{t('common:actions.reset_filters')}</Button>
                </ResetFilters>
            ) : null}
        </ListToolbar>
    );
};

export { ListFilters };
